import { render, staticRenderFns } from "./ExamReport.vue?vue&type=template&id=4338f89e&scoped=true&"
import script from "./ExamReport.vue?vue&type=script&lang=js&"
export * from "./ExamReport.vue?vue&type=script&lang=js&"
import style0 from "./ExamReport.vue?vue&type=style&index=0&id=4338f89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338f89e",
  null
  
)

export default component.exports